import type { IconSvgObject } from './types';

const CornerDownRightIcon: IconSvgObject = [
  ["path", { d: "M19 15.002H12C8.22876 15.002 6.34315 15.002 5.17157 13.8304C4 12.6588 4 10.7732 4 7.00195V4.00195", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 20.002C15 20.002 20 16.3195 20 15.0019C20 13.6843 15 10.002 15 10.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CornerDownRightIcon;
